/**
 * Set Planner free-plan limits, as the UI mirrors them.
 *
 * The real enforcement is NOT here: recommendation steps are counted in the
 * Electron main process (src/backend/plannerFreeQuota.js) and saved sets are
 * capped by the main process + user-library-service. These helpers only keep
 * the copy, hints and pre-flight checks in one place. On web/native there is
 * no main process, so `localPlannerQuota` applies the same step rule locally —
 * renderer-only there by design (server-side enforcement is the open P2 item).
 */
export const FREE_STEP_LIMIT = 5;
export const FREE_SET_LIMIT = 3;

/** A NEW set may be created when GOAT, or while under the free cap. Overwrites are always fine. */
export const canCreateNewSet = (savedCount, isGoat) => Boolean(isGoat) || (savedCount || 0) < FREE_SET_LIMIT;

const KEY = 'planner:freeSteps';

/** Web/native fallback for the main-process quota: one step per node, FREE_STEP_LIMIT per set. */
export function localPlannerQuota(userId, { planId, nodeId } = {}, storage = (typeof localStorage !== 'undefined' ? localStorage : null)) {
    let all = {};
    try { all = JSON.parse(storage?.getItem(KEY) || '{}') || {}; } catch { all = {}; }
    const u = String(userId || 'anonymous');
    const p = String(planId || 'scratch');
    const n = String(nodeId || 'seed');
    all[u] = all[u] || {};
    const nodes = Array.isArray(all[u][p]) ? all[u][p] : [];
    const snapshot = (allowed, reason) => ({ allowed, reason, used: nodes.length, limit: FREE_STEP_LIMIT });
    if (nodes.includes(n)) return snapshot(true, 'already-counted');
    if (nodes.length >= FREE_STEP_LIMIT) return snapshot(false, 'set-limit');
    nodes.push(n);
    all[u][p] = nodes;
    try { storage?.setItem(KEY, JSON.stringify(all)); } catch { /* quota / private mode */ }
    return snapshot(true, 'ok');
}
